module.exports = __webpack_public_path__ + "static/media/wu_bills_grayArrow.d026c1c1.svg";